import {mdiCheck, mdiClose} from '@mdi/js'
import Icon from '@mdi/react'
import {CircularProgress, IconButton, Tooltip} from '@mui/material'

// Legacy-stack twin of pages-new/secondaryAssumptions/QuickAnswerButtonsNew. One-tap answer for a
// reminder still awaiting a response: a round "not taken" and a round "taken" button, replacing a
// text link. `onDeny` fires immediately (CANCELLED has nothing left to ask — RF4/RF1.2), `onConfirm`
// instead opens the follow-up asking when/where, since a COMPLETED answer may still need a time
// and a body part.

type QuickAnswerButtonsProps = {
  onDeny: () => void
  onConfirm: () => void
  denyLoading?: boolean
}

const CIRCLE_STYLE = {width: 32, height: 32, backgroundColor: 'transparent'} as const

const QuickAnswerButtons: React.FC<QuickAnswerButtonsProps> = ({onDeny, onConfirm, denyLoading}) => (
  <div style={{display: 'flex', gap: 8}}>
    <Tooltip title='Segna come non assunta'>
      <span>
        <IconButton
          aria-label='Segna come non assunta'
          disabled={denyLoading}
          onClick={onDeny}
          size='small'
          style={{...CIRCLE_STYLE, color: '#DC2626', border: '2px solid #DC2626'}}
        >
          {denyLoading ? <CircularProgress size={16} style={{color: '#DC2626'}} /> : <Icon path={mdiClose} size={0.7} />}
        </IconButton>
      </span>
    </Tooltip>
    <Tooltip title='Segna come assunta'>
      <IconButton
        aria-label='Segna come assunta'
        disabled={denyLoading}
        onClick={onConfirm}
        size='small'
        style={{...CIRCLE_STYLE, color: '#16A34A', border: '2px solid #16A34A'}}
      >
        <Icon path={mdiCheck} size={0.7} />
      </IconButton>
    </Tooltip>
  </div>
)

export default QuickAnswerButtons
